// ----
// ref - https://codepen.io/idorenyinudoh/pen/GRjBXER
// ----

document.addEventListener('DOMContentLoaded', () => {
  const audioPlayer = document.querySelectorAll('.mod-audio');

  const calculateTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${returnedSeconds}`;
  };

  audioPlayer.forEach((element) => {
    const audioPlayerContainer = element;
    const playIconContainer = element.querySelector('.mod-audio__play');
    const audioElem = element.querySelector('.mod-audio__audio');
    const seekSlider = element.querySelector('.mod-audio__seek-slider');
    const volumeSlider = element.querySelector('.mod-audio__volume-slider-input');
    const volumeButton = element.querySelector('.mod-audio__volume-button');
    const reloadButton = element.querySelector('.mod-audio__reload');
    const durationContainer = element.querySelector('.mod-audio__time-total');
    const currentTimeContainer = element.querySelector('.mod-audio__time-current');
    const nextItem = element.querySelector('.mod-audio__next');
    const prevItem = element.querySelector('.mod-audio__previous');
    let raf = null;
    let playState = 'play';
    let muteState = 'unmute';

    const whilePlaying = () => {
      seekSlider.value = Math.floor(audioElem.currentTime);
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      audioPlayerContainer.style.setProperty('--seek-before-width', `${(seekSlider.value / seekSlider.max) * 100}%`);
      raf = requestAnimationFrame(whilePlaying);
    };

    playIconContainer.addEventListener('click', () => {
      if (playState === 'play') {
        audioElem.play();
        playIconContainer.classList.add('is-playing');
        requestAnimationFrame(whilePlaying);
        playState = 'pause';
      } else {
        audioElem.pause();
        playIconContainer.classList.remove('is-playing');
        cancelAnimationFrame(raf);
        playState = 'play';
      }
    });

    volumeButton.addEventListener('click', (e) => {
      const button = e.currentTarget;
      if (muteState === 'unmute') {
        audioElem.muted = true;
        button.classList.add('is-muted');
        muteState = 'mute';
      } else {
        audioElem.muted = false;
        button.classList.remove('is-muted');
        muteState = 'unmute';
      }
    });

    reloadButton.addEventListener('click', () => {
      audioElem.load();
      audioElem.play();
    });

    const showRangeProgress = (rangeInput) => {
      if (rangeInput === seekSlider)
        audioPlayerContainer.style.setProperty('--seek-before-width', `${(rangeInput.value / rangeInput.max) * 100}%`);
      else
        audioPlayerContainer.style.setProperty(
          '--volume-before-width',
          `${(rangeInput.value / rangeInput.max) * 100}%`,
        );
    };

    seekSlider.addEventListener('input', (e) => {
      showRangeProgress(e.target);
    });

    volumeSlider.addEventListener('input', (e) => {
      showRangeProgress(e.target);
    });

    const displayDuration = () => {
      durationContainer.textContent = calculateTime(audioElem.duration);
    };

    const setSliderMax = () => {
      seekSlider.max = Math.floor(audioElem.duration);
    };

    const displayBufferedAmount = () => {
      if (audioElem.buffered.length) {
        const bufferedAmount = Math.floor(audioElem.buffered.end(audioElem.buffered.length - 1));
        audioPlayerContainer.style.setProperty('--buffered-width', `${(bufferedAmount / seekSlider.max) * 100}%`);
      }
    };

    const audioFunctions = () => {
      displayBufferedAmount();
      displayDuration();
      setSliderMax();
    };

    if (audioElem.readyState > 0) {
      audioFunctions();
    } else {
      audioElem.addEventListener('loadedmetadata', () => {
        audioFunctions();
      });
    }

    audioElem.addEventListener('progress', displayBufferedAmount);

    seekSlider.addEventListener('input', () => {
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      if (!audioElem.paused) {
        cancelAnimationFrame(raf);
      }
    });

    seekSlider.addEventListener('change', () => {
      audioElem.currentTime = seekSlider.value;
      if (!audioElem.paused) {
        requestAnimationFrame(whilePlaying);
      }
    });

    volumeSlider.addEventListener('input', (e) => {
      const volumeValue = e.target.value;
      audioElem.volume = volumeValue / 100;
      volumeButton.classList.toggle('is-muted', volumeValue <= 0);
    });

    // PlayList
    // RESET PLAYER
    const resetPlayerUI = () => {
      cancelAnimationFrame(raf);
      playState = 'play';

      playIconContainer.classList.remove('is-playing');
      seekSlider.value = 0;
      currentTimeContainer.textContent = '0:00';
      durationContainer.textContent = '0:00';

      audioPlayerContainer.style.setProperty('--seek-before-width', '0%');
      audioPlayerContainer.style.setProperty('--buffered-width', '0%');
    };

    // LOAD AUDIO FROM PLAYLIST
    const loadAudio = (url) => {
      resetPlayerUI();

      audioElem.src = url;
      audioElem.load();

      audioElem.addEventListener(
        'loadedmetadata',
        () => {
          seekSlider.max = Math.floor(audioElem.duration);
          durationContainer.textContent = calculateTime(audioElem.duration);

          audioElem.play();
          playIconContainer.classList.add('is-playing');
          playState = 'pause';
          requestAnimationFrame(whilePlaying);
        },
        { once: true },
      );
    };

    audioPlayerContainer.loadAudio = loadAudio;
    const audioPlayListModule = audioPlayerContainer.closest('[data-audio-playlist]');
    if (!audioPlayListModule) return;
    const playlistButtons = audioPlayListModule.querySelectorAll('.audio-module__list-item');

    if (playlistButtons.length > 1) {
      audioPlayListModule.querySelectorAll('.mod-audio__control').forEach((button) => button.classList.remove('hide'));
    }

    let currentIndex = 0;

    // UPDATE CONTROLS STATE
    const updateControlsState = () => {
      prevItem.classList.toggle('is-disabled', currentIndex === 0);
      nextItem.classList.toggle('is-disabled', currentIndex === playlistButtons.length - 1);
    };

    // LOAD BY INDEX
    const loadByIndex = (index) => {
      const button = playlistButtons[index];
      if (!button) return;

      const { audioUrl } = button.dataset;
      if (!audioUrl) return;

      loadAudio(audioUrl);

      playlistButtons.forEach((btn) => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      currentIndex = index;
      updateControlsState();
    };

    playlistButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        loadByIndex(index);
      });
    });

    nextItem.addEventListener('click', () => {
      if (currentIndex >= playlistButtons.length - 1) return;
      loadByIndex(currentIndex + 1);
    });

    prevItem.addEventListener('click', () => {
      if (currentIndex <= 0) return;
      loadByIndex(currentIndex - 1);
    });

    updateControlsState();
  });
});
